<template class="bg-radial from-purple-900 to-indigo-500">
  <footer class="p-4 rounded-lg shadow md:px-6 md:py-8 dark:bg-gray-800">
    <div class="sm:flex sm:items-center sm:justify-between">
      <span
        class="self-center text-slate-500 hover:text-blue-600 text-lg sm:text-5xl md:text-6xl font-bold mb-8 md:mb-12"
        >Afrihost</span
      >

      <ul
        class="flex flex-wrap items-center mb-6 text-sm text-gray-500 sm:mb-0 dark:text-gray-400"
      >
        <li>
          <a href="#" class="mr-4 hover:underline md:mr-6">Privacy Policy</a>
        </li>
        <li>
          <a href="#" class="mr-4 hover:underline md:mr-6">Licensing</a>
        </li>
      </ul>
    </div>
    <hr class="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" />
    <span class="block text-sm text-gray-500 sm:text-center dark:text-gray-400"
      >© afrihost 2022 All Rights Reserved.
    </span>
  </footer>
</template>
